// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `app-featured-cards, app-search-result-page, app-paginator {
    display: contents;
}

.search {
  margin-top: 42px;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
}
.search > * {
  margin-bottom: 24px;
}

  .search > *:last-child > .search--results {
    margin-bottom: 0;
    margin-top: 32px;
  }

/* Layout for Desktop */
@media (min-width: 768px) {
  .search {
    flex-direction: row;
  }

  .search--input, .paginator {
    width: calc(100% * 8/12 - 24px);
  }

  .paginator {
    margin-left: 0;
    margin-top: -40px;
  }

  .search--featured {
    margin-top: -74px;
    width: calc(100% * 4/12);
    order: 3;
  }

  .search--results {
    margin-right: 24px;
    width: calc(100% * 8/12 - 24px);
    order: 2;
  }

  .search > *:last-child > .search--results {
    margin-top: 0;
  }
}

.nsw-header-btn__icon {
  height: 1.5rem;
  width: 1.5rem;
}

.search--input {
  display: flex;
  position: relative;
  background-color: #f4f4f7;
}

.search--input > * {
  min-height: 100%;
  background-color: transparent;
}

  .search--input .nsw-form-input {
    width: 100%;
  }

    .search--input .nsw-form-input:hover {
      background-color: transparent;
    }

  .search--input button {
    width: 10%;
    cursor: pointer;
    border: 0;
    background-color: transparent;
    position: absolute;
    height: 50px;
    width: 50px;
    right: 0;
  }
`, "",{"version":3,"sources":["webpack://./src/app/search/search.component.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;;EAEE;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;AAEF,uBAAuB;AACvB;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,wBAAwB;IACxB,QAAQ;EACV;;EAEA;IACE,kBAAkB;IAClB,+BAA+B;IAC/B,QAAQ;EACV;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;AAC/B;;EAEE;IACE,WAAW;EACb;;IAEE;MACE,6BAA6B;IAC/B;;EAEF;IACE,UAAU;IACV,eAAe;IACf,SAAS;IACT,6BAA6B;IAC7B,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,QAAQ;EACV","sourcesContent":["app-featured-cards, app-search-result-page, app-paginator {\r\n    display: contents;\r\n}\r\n\r\n.search {\r\n  margin-top: 42px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  flex-wrap: wrap;\r\n}\r\n.search > * {\r\n  margin-bottom: 24px;\r\n}\r\n\r\n  .search > *:last-child > .search--results {\r\n    margin-bottom: 0;\r\n    margin-top: 32px;\r\n  }\r\n\r\n/* Layout for Desktop */\r\n@media (min-width: 768px) {\r\n  .search {\r\n    flex-direction: row;\r\n  }\r\n\r\n  .search--input, .paginator {\r\n    width: calc(100% * 8/12 - 24px);\r\n  }\r\n\r\n  .paginator {\r\n    margin-left: 0;\r\n    margin-top: -40px;\r\n  }\r\n\r\n  .search--featured {\r\n    margin-top: -74px;\r\n    width: calc(100% * 4/12);\r\n    order: 3;\r\n  }\r\n\r\n  .search--results {\r\n    margin-right: 24px;\r\n    width: calc(100% * 8/12 - 24px);\r\n    order: 2;\r\n  }\r\n\r\n  .search > *:last-child > .search--results {\r\n    margin-top: 0;\r\n  }\r\n}\r\n\r\n.nsw-header-btn__icon {\r\n  height: 1.5rem;\r\n  width: 1.5rem;\r\n}\r\n\r\n.search--input {\r\n  display: flex;\r\n  position: relative;\r\n  background-color: #f4f4f7;\r\n}\r\n\r\n.search--input > * {\r\n  min-height: 100%;\r\n  background-color: transparent;\r\n}\r\n\r\n  .search--input .nsw-form-input {\r\n    width: 100%;\r\n  }\r\n\r\n    .search--input .nsw-form-input:hover {\r\n      background-color: transparent;\r\n    }\r\n\r\n  .search--input button {\r\n    width: 10%;\r\n    cursor: pointer;\r\n    border: 0;\r\n    background-color: transparent;\r\n    position: absolute;\r\n    height: 50px;\r\n    width: 50px;\r\n    right: 0;\r\n  }\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
